import { FieldType } from "../api.js";
const BaseModelConvertSpec = {
  createdAt: FieldType.DateTime,
  updatedAt: FieldType.DateTime,
  deletedAt: FieldType.DateTime
};
export {
  BaseModelConvertSpec
};
